<template>
  <div class="level-row d-flex ga-6 w-100">
    <div class="level-col-level level-name-cell d-flex ga-2">
      <div class="level-drag-slot">
        <JobProfileDragHandle
          label="Reorder level"
          :disabled="disabled"
        />
      </div>
      <div
        v-if="canEdit"
        class="level-name-input text-body-2"
      >
        <DpplTextField
          label=""
          placeholder="Level Name"
          aria-label="Level name"
          :model-value="level.name"
          :error-messages="error ? [error] : []"
          :disabled="disabled"
          @update:model-value="emit('update:name', $event)"
          @blur="emit('blur')"
        >
          <template #message="{ message }">
            <span class="text-caption text-error">{{ message }}</span>
          </template>
        </DpplTextField>
      </div>
      <span
        v-else
        class="level-name text-h2 text-textDarkest"
      >{{ level.name }}</span>
    </div>
    <div class="level-col-shortened text-body-2">
      <DpplTextField
        label=""
        placeholder="Alias"
        :aria-label="`Shortened label for ${level.name}, max 5 characters`"
        :model-value="level.short_name"
        maxlength="5"
        :disabled="disabled"
        @update:model-value="emit('update:alias', $event)"
      />
    </div>
  </div>
</template>

<script setup>
import DpplTextField from '@/components/datapeople/DpplTextField.vue';
import JobProfileDragHandle from '@/components/settings/components/JobProfileDragHandle.vue';

defineProps({
  level: { type: Object, required: true },
  error: { type: String, default: '' },
  canEdit: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
});

const emit = defineEmits(['update:name', 'update:alias', 'blur']);
</script>

<style scoped lang="less">
.level-row {
  align-items: flex-start;
  box-sizing: border-box;
}

.level-col-level {
  flex: 0 0 400px;
  width: 400px;
}

.level-col-shortened {
  flex: 0 0 100px;
  width: 100px;
}

.level-name-cell {
  align-items: flex-start;
  min-width: 0;
}

.level-drag-slot {
  width: 32px;
  height: 40px;
  flex-shrink: 0;

  :deep(.drag-handle) {
    width: 100%;
    height: 100%;
  }
}

.level-name {
  display: flex;
  align-items: center;
  min-width: 0;
  height: 40px;
}

.level-name-input {
  flex: 1;
  min-width: 0;

  :deep(.v-input__details) {
    min-height: 0;
    margin-top: 2px;
  }
}

.level-name-input,
.level-col-shortened {
  :deep(.text-field-container) {
    width: 100%;
  }

  :deep(.form-label-text) {
    display: none;
  }

  :deep(.v-text-field) {
    margin-top: 0 !important;
  }

  :deep(.v-field) {
    height: 40px;
    border-radius: 8px;
    background-color: transparent;

    .v-field__input {
      align-items: center;
      height: 40px;
      min-height: 40px;
      padding: 0;
    }
  }

  :deep(.v-field__outline),
  :deep(.v-field:hover .v-field__outline),
  :deep(.v-field--focused .v-field__outline) {
    color: @stroke-default !important;
    --v-field-border-opacity: 1;
  }

  :deep(.v-field--error .v-field__outline),
  :deep(.v-field--error:hover .v-field__outline),
  :deep(.v-field--error.v-field--focused .v-field__outline) {
    color: @text-error !important;
  }

  :deep(input) {
    box-sizing: border-box;
    height: 40px;
    min-height: 0;
    padding: 0 16px;
    font: inherit !important;
    color: @text-darkest;

    &::placeholder {
      color: @text-lighter;
      opacity: 1;
    }
  }
}
</style>
